import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { apiService } from "../service/Api";

const useCollateral = () => {
   

    const { key } = useParams();
    const [collateralData, setCollateralData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetchCollateral();
    }, [key]);

    const fetchCollateral = async () => {
        try {
            setLoading(true);
            const response = await apiService.gettailspinCollateral(key);
            console.log('Collateral response:', response.data);
            // Access the data from axios response
            setCollateralData(response.data);
        } catch (err) {
            setError('Failed to fetch collateral data');
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    return { collateralData, loading, error};

};

export default useCollateral;


